



































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { GradeSchoolClass, SchoolClass, SchoolClassSelection } from '@/models/school-class/school-class';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';

@Component({
  name: 'GJgrowEventCreateExamineeSettingSchoolClasses',
  computed: {},
  methods: {},
})
export default class GJgrowEventCreateExamineeSettingSchoolClasses extends mixins(GPageBase) {
  mounted() {}

  gradeLabel(index: number, schoolClasses: SchoolClass[]): any {
    if (this.selectionSchoolClasses[index] === undefined) {
      return;
    }
    return (h: any) => {
      return h('div', [
        h('span', this.gradeSchoolClassesIncludeSelected[index].grade + this.$t('YEAR').toString()),
        h('Badge', {
          props: {
            type: 'primary',
            count: this.selectionSchoolClasses[index].notSelectedIDs(schoolClasses).length,
          },
        }),
      ]);
    };
  }

  get gradeSchoolClassesIncludeSelected(): GradeSchoolClass[] {
    return schoolClassModule.gradeSchoolClassesIncludeSelected;
  }

  get selectionSchoolClasses(): SchoolClassSelection[] {
    return jgrowEventCreateModule.selectionSchoolClasses;
  }
}
